import { render, staticRenderFns } from "./company2.vue?vue&type=template&id=450142de&scoped=true"
import script from "./company2.vue?vue&type=script&lang=js"
export * from "./company2.vue?vue&type=script&lang=js"
import style0 from "./company2.vue?vue&type=style&index=0&id=450142de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450142de",
  null
  
)

export default component.exports